import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue,orderByChild,startAt,endAt} from "firebase/database";
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';

const useObtenerViajes15minutos = (fechahoraviaje) => {
    function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum;
     }

     const formatearFechaHora = (fecha) => {
		return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy HH':'mm'", {locale: es})
	}

    const [viajes, cambiarViajes] = useState([]);
    //Filtro Editar distinto manejo de fechas
    //var fechaInicio15 = (toTimestamp(fechahoraviaje)/1000)-900
    //var fechaFin15 = (toTimestamp(fechahoraviaje)/1000)+900
    //Filtro Crear distinto manejo de fechas
    var fechaInicio15 = (toTimestamp(fechahoraviaje))-900000
    var fechaFin15 = (toTimestamp(fechahoraviaje))+900000
    
    console.log(formatearFechaHora(Number((fechaInicio15/1000))))
    console.log(formatearFechaHora(Number((fechaFin15/1000))))


    useEffect( () => {
        cambiarViajes([]);
        const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('fecha_hora_programada'),startAt(fechaInicio15),endAt(fechaFin15));
        console.log("llama base de viajes");
        return onValue(consulta, (snapshot) => {
           
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
           
            cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
          
            });
    },{
        onlyOnce: true
      }
    );            
    }, [fechaFin15]);
    return (viajes);
}
export default useObtenerViajes15minutos;